import cryptDecrypt from '../core/crypt-decrypt';

const modCryptDecrypt = new cryptDecrypt("25a02a871c482b08a36db790703c455c03e8e38d37d9615ba4b98be07f7a6842");

// Interface for Booking Data
interface BookingData {
    order_uuid: string;
    created_at: string;
    room_id: number;
    room_name: string;
    game_name: string;
    arena_id: number;
    type_arena: string;
    mode: string;
    game_id: number;
    date_start: string;
    date_end: string;
    players: number;
    price_paid: string;
    price_left: string;
    price_total: string;
    time: string;
    slot_time: string;
    day: string;
    name: string;
    surname: string;
    email: string;
    phone_prefix_id: number;
    phone: string;
    phone_full: string;
}

export default class bookingDataStorage{

    /**
     * Get local storage values
     * @returns 
     */
    getLocalStorage(): BookingData | null{
        
        try{
            
            const storedData = localStorage.getItem('booking-data-order');

            if(!storedData) return null;

            const { encryptedData, iv } = JSON.parse(storedData);

            return modCryptDecrypt.decryptObject<BookingData>(encryptedData, iv);

        }catch(error){
            
            // console.error("Error retrieving booking data:", error);
            return null;

        }

    }

    /**
     * Remove local storage values
     */
    removeStoredValue(){

        localStorage.removeItem('booking-data-order');
        
    }

    /**
     * Get step in local storage
     * @returns
     */
    getStorageStep(){
        
        const value = localStorage.getItem("booking-step-order");

        if(value === null){
            
            return null;

        }else{
            
            const numberValue: number = value ? Number(value) : 0;

            return numberValue;

        }
        
    }

    /**
     * Set step in local storage
     */
    setStorageStep(){
        
        localStorage.setItem('booking-step-order', '3');

    }

    /**
     * Remove step in local storage
     */
    removeStorageStep(){
        
        localStorage.removeItem('booking-step-order');

    }

    /**
     * Remove expired data
     * @param key 
     * @param expirationMinutes 
     * @returns 
     */
    removeStorageByTime<T>(expirationMinutes: number = 10): BookingData | null{

        const data = this.getLocalStorage();

        // Return null if no data is found
        if (!data) return null; 
        
        // If created_at is missing, return null
        if(!data.created_at) return null; 
        
        // Convert to timestamp
        const createdAt = new Date(data.created_at).getTime();
        const now = Date.now();

        // Convert minutes to milliseconds
        const expirationTime = expirationMinutes * 60 * 1000; 
    
        if(now - createdAt > expirationTime){
            
            // Remove expired data
            this.removeStoredValue();
            return null;

        }
        
        // Return data if it's still valid
        return data; 
        
    }

}